module.exports = __webpack_public_path__ + "static/media/argon-dashboard-pro-react.38e5c13e.jpg";